import { ScrapeUiStatus } from '@/enums/ScrapeUiStatus';

/** Pure helper that derives the UI status from two simple flags. */
export function computeUiStatus(
    isPaused: boolean,
    activeFetches: number,
): ScrapeUiStatus {
    if (isPaused) return ScrapeUiStatus.PAUSED;
    if (activeFetches > 0) return ScrapeUiStatus.RUNNING;
    return ScrapeUiStatus.READY;
}
